import { MantineProvider } from "@mantine/core";
import { ModalsProvider } from "@mantine/modals";
import { NotificationsProvider } from "@mantine/notifications";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import { GlobalStyle, themeConfig } from "./mantine";
import reportWebVitals from "./reportWebVitals";
import { persistor, store } from "./store";
import "./styles/base.css";

navigator.serviceWorker
  .register("/firebase-messaging-sw.js")
  .then((reg) => console.log("Service Worker Registered:", reg))
  .catch((err) => console.log("Service Worker Registration Failed:", err));

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <MantineProvider theme={{ ...themeConfig }} withGlobalStyles withNormalizeCSS>
            <ModalsProvider>
              <GlobalStyle />
              <NotificationsProvider position="top-right">
                <App />
              </NotificationsProvider>
            </ModalsProvider>
          </MantineProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
